import { Link, NavLink, Outlet, useNavigate } from "react-router-dom"
import { LogOut, Monitor, KeyRound } from "lucide-react"
import { useAuth } from "../../hooks/useAuth"
import logo from "../../assets/logo.png"

const baseTabs = [
  { label: "Entrenamiento", to: "/dashboard/training" },
  { label: "CRM & Pagos", to: "/dashboard/crm" },
  { label: "Modelo Financiero", to: "/dashboard/financial" },
  { label: "Biblioteca de Ejercicios", to: "/dashboard/exercises" },
  { label: "Galería de Rutinas", to: "/dashboard/routines" },
  { label: "Agenda de Citas", to: "/dashboard/appointments" },
]

const adminTab = { label: "Admin", to: "/dashboard/admin" }

export default function AppShell() {
  const { logout, isAdmin } = useAuth()
  const navigate = useNavigate()
  const tabs = isAdmin ? [...baseTabs, adminTab] : baseTabs

  async function handleLogout() {
    await logout()
    navigate("/login")
  }

  return (
    <div className="min-h-screen">
      {/* Header */}
      <header className="gradient-header bg-grid-pattern border-b border-white/10 px-3 py-3 sm:px-6 sm:py-4">
        <div className="flex items-center justify-between">
          {/* Logo + Title */}
          <div className="flex items-center gap-3">
            <img src={logo} alt="Science Fitness" className="h-8 w-auto sm:h-10" />
            <div>
              <h1
                className="text-sm sm:text-lg font-bold tracking-widest text-primary glow-cyan-text uppercase"
                style={{ fontFamily: "var(--font-display)" }}
              >
                Trainer Dashboard
              </h1>
              <p className="hidden sm:block text-xs text-muted">Gestión de clientes y programas</p>
            </div>
          </div>

          {/* Actions */}
          <div className="flex items-center gap-2 sm:gap-4">
            <Link
              to="/display"
              className="flex items-center gap-1.5 text-sm text-muted hover:text-primary transition-colors"
            >
              <Monitor size={14} />
              <span className="hidden sm:inline">Vista Display</span>
            </Link>
            <Link
              to="/change-password"
              className="flex items-center gap-1.5 text-sm text-muted hover:text-primary transition-colors"
            >
              <KeyRound size={14} />
              <span className="hidden sm:inline">Cambiar contraseña</span>
            </Link>
            <button
              onClick={handleLogout}
              className="flex items-center gap-1.5 text-sm text-muted hover:text-danger transition-colors"
            >
              <LogOut size={14} />
              <span className="hidden sm:inline">Salir</span>
            </button>
          </div>
        </div>

        {/* Tabs - scrollable on mobile */}
        <nav className="mt-3 flex gap-1 overflow-x-auto pb-0.5 [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
          {tabs.map((tab) => (
            <NavLink
              key={tab.to}
              to={tab.to}
              className={({ isActive }) =>
                `whitespace-nowrap px-3 pb-2 pt-1 text-xs sm:px-4 sm:text-sm font-medium transition-all border-b-2 ${
                  isActive
                    ? "border-primary text-primary glow-cyan-text"
                    : "border-transparent text-muted hover:text-white hover:border-white/30"
                }`
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </nav>
      </header>

      {/* Content */}
      <main className="p-3 sm:p-6">
        <Outlet />
      </main>
    </div>
  )
}
